"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUTTON_STATE_TYPES = exports.BUTTON_SIZE_TYPES = exports.BUTTON_TYPES = void 0;
var BUTTON_TYPES;
(function (BUTTON_TYPES) {
    BUTTON_TYPES["PRIMARY"] = "PRIMARY";
    BUTTON_TYPES["SECONDARY"] = "SECONDARY";
    BUTTON_TYPES["TEXT_NAV"] = "TEXT_NAV";
})(BUTTON_TYPES = exports.BUTTON_TYPES || (exports.BUTTON_TYPES = {}));
var BUTTON_SIZE_TYPES;
(function (BUTTON_SIZE_TYPES) {
    BUTTON_SIZE_TYPES["LARGE"] = "LARGE";
    BUTTON_SIZE_TYPES["MEDIUM"] = "MEDIUM";
    BUTTON_SIZE_TYPES["SMALL"] = "SMALL";
    BUTTON_SIZE_TYPES["XSMALL"] = "XSMALL";
})(BUTTON_SIZE_TYPES = exports.BUTTON_SIZE_TYPES || (exports.BUTTON_SIZE_TYPES = {}));
var BUTTON_STATE_TYPES;
(function (BUTTON_STATE_TYPES) {
    BUTTON_STATE_TYPES["DEFAULT"] = "DEFAULT";
    BUTTON_STATE_TYPES["HOVER"] = "HOVER";
    BUTTON_STATE_TYPES["PRESSED"] = "PRESSED";
    BUTTON_STATE_TYPES["DISABLED"] = "DISABLED";
    BUTTON_STATE_TYPES["LOADING"] = "LOADING";
})(BUTTON_STATE_TYPES = exports.BUTTON_STATE_TYPES || (exports.BUTTON_STATE_TYPES = {}));
